import React from "react";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import PackageOne from "../../components/Combo-Packages/package-one";
import PackageSilver from "../../components/Combo-Packages/package-silver";
import PackageGold from "../../components/Combo-Packages/package-gold";
import PackagePromotional from "../../components/Combo-Packages/package-promotional";
import { Helmet } from "react-helmet";

function Package() {
  return (
    <>
      <Helmet>
        <title>Combo Packages – The Digital Creative Designs USA</title>
        <meta
          name="description"
          content="Explore The Digital Creative Designs’s combo packages for affordable, tailored graphic design solutions in USA."
        />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="author" content="The Digital Creative Designs" />
        <meta
          property="og:title"
          content="Combo Packages – The Digital Creative Designs USA"
        />
        <meta
          property="og:description"
          content="Explore The Digital Creative Designs’s combo packages for affordable, tailored graphic design solutions in USA."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="The Digital Creative Designs US" />
        <meta
          property="og:url"
          content="https://thedigitalcreativedesigns.com/combo-packages"
        />
        <meta
          property="og:image"
          content="https://thedigitalcreativedesigns.com/img/logo1.png"
        />

        <link
          rel="canonical"
          href="https://thedigitalcreativedesigns.com/combo-packages"
        />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title="Combo Packages"
          subtitle={"Combo Packages"}
          className={"pt-175 pb-140"}
        />
        <PackageOne />
        <PackageSilver />
        <PackageGold />
        <PackagePromotional />
      </Layout>
    </>
  );
}

export default Package;
